/**
 * 接口文档：
 * http://39.107.140.109/goplatform/swagger/
 * http://39.107.140.109/trainingApi/swagger/
 * https://test.qiangguoxianfeng.com/trainingApi/swagger/index.html
 */

const API = {
  // common
  uploadFile: "/goplatform/v1/base/uploadFile", // 上传文件
  getEnumByCode: "/goplatform/v1/base/getEnumByCode", // 获取字典数据
  getSetting: "/goplatform/v1/system/getSetting", // 获取基础配置
  getAppSetting: "/trainingApi/v1/base/getAppSetting", // 获取app配置
  // user
  generateCaptcha: "/trainingApi/v1/user/generateCaptcha", // 生成登录验证码
  getCaptcha: "/trainingApi/v1/user/getCaptcha", // 获取登录验证码
  userLogin: "/trainingApi/v1/user/login", // 用户密码登录
  userLogout: "/trainingApi/v1/user/logout",
  userForgetPwd: "/trainingApi/v1/user/forgetPwd", // 忘记密码-找回密码
  userRegister: "/trainingApi/v1/user/register", // 用户注册 (json)
  // 首页
  cmsBanners: "/trainingApi/v1/cms/banners", // 首页banner轮播图
  cmsNotices: "/trainingApi/v1/cms/notices", // 首页通知公告
  cmsNoticeList: "/trainingApi/v1/cms/noticeList", // 通知公告列表
  cmsNoticeDetail: "/trainingApi/v1/cms/noticeDetail", // 通知公告详情
  cmsCategoryChildren: "/trainingApi/v1/cms/categoryChildren", // 首页知党情 跟党走
  cmsNewListTop: "/trainingApi/v1/cms/newListTop", // 获取栏目指定数量的文章
  cmsNewList: "/trainingApi/v1/cms/newList", // 获取栏目文章列表
  cmsNewDetail: "/trainingApi/v1/cms/newDetail", // 获取文章详情
  cmsLessonInfo: "/trainingApi/v1/lesson/lessonInfo", // 首页学习任务-学习
  cmsIndexWorkStatus: "/trainingApi/v1/work/indexWorkStatus", // 首页学习任务-作业
  cmsExamStatus: "/trainingApi/v1/user/examStatus", // 首页学习任务-考试
  // 专题
  topicList: "/trainingApi/v1/topic/topicList", // 专题列表
  topicExamInfo: "/trainingApi/v1/topic/examInfo", // 专题考试信息
  topicDetail: "/trainingApi/v1/topic/topicDetail", // 专题详情，学习情况
  topicExpertList: "/trainingApi/v1/topic/topicExpertList", // 专题专家列表
  topicWorkDetail: "/trainingApi/v1/topic/workDetail", // 专题列专题心得体会作业详情表
  topicExpertDetail: "/trainingApi/v1/topic/topicExpertDetail", // 专家介绍详情
  topicWriteExperience: "/trainingApi/v1/topic/writeExperience", // 作业写心得
  topicNoticeList: "/trainingApi/v1//topic/noticeList", // 专题通知
  topicLessonSubList: "/trainingApi/v1/topic/lessonSubList", // 专题知识分类
  topicLearnNewsList: "/trainingApi/v1/topic/learnNewsList", // 学习资料列表
  // 课程
  lessonInfo: "/trainingApi/v1/lesson/lessonInfo", // 课程信息
  lessonCenter: "/trainingApi/v1/lesson/lessonCenter", // 选课中心
  lessonVideoDetail: "/trainingApi/v1/lesson/lessonVideoDetail", // 章节详情视频详情
  selectVideo: "/trainingApi/v1/lesson/selectVideo", // 提交选课/取消选课
  stageLesson: "/trainingApi/v1/lesson/stageLesson", // 章节
  getLessonSub: "/trainingApi/v1/lesson/lessonSubList", // 章节知识分类
  lessonVideos: "/trainingApi/v1/lesson/lessonVideos", // 章节详情视频列表
  lessonLecture: "/trainingApi/v1/lesson/lessonLecture", // 讲义详情
  lessonReadList: "/trainingApi/v1/lesson/lessonReadList", // 延伸阅读列表
  lessonReadDetail: "/trainingApi/v1/lesson/lessonReadDetail", // 延伸阅读文章内容
  noteList: "/trainingApi/v1/lesson/noteList", // 随堂笔记列表
  writeNote: "/trainingApi/v1/lesson/writeNote", // 随堂笔记-写笔记或编辑笔记
  delNote: "/trainingApi/v1/lesson/delNote", // 随堂笔记-删除笔记
  videoZan: "/trainingApi/v1/lesson/videoZan", // 给视频课程点赞
  lessonVideoResourceDetail: "/trainingApi/v1/lesson/lessonVideoResourceDetail", // 单个视频详情
  setResourceTime: "/trainingApi/v1/lesson/setResourceTime", // 课程详情－保存视频播放时间点
  studyTime: "/trainingApi/v1/lesson/studyTime", // 理论学习-记录学习时长（）
  setResourceStart: "/trainingApi/v1/lesson/setResourceStart", // 课程详情－保存视频播放开始记录
  setResourceComplete: "/trainingApi/v1/lesson/setResourceComplete", // 课程详情－保存视频播放完成记录
  lessonTagList: "/trainingApi/v1/lesson/lessonTagList", // 章节分类
  lessonSubList: "/trainingApi/v1/lesson/lessonSubList", // 知识分类
  lessonVideoResourceList: "/trainingApi/v1/lesson/lessonVideoResourceList", //视频资源列表
  tags: "/trainingApi/v1/lesson/tags", //标签
  myStudyTimes: "/trainingApi/v1/lesson/myStudyTimes", //我的学习时间
  discussList: "/trainingApi/v1/lesson/discussList", //讨论列表
  writeDiscuss: "/trainingApi/v1/lesson/writeDiscuss", ///写讨论
  lessonTagVideos: "/trainingApi/v1/lesson/lessonTagVideos", ///视频
  discussCount: "/trainingApi/v1/lesson/discussCount", // 课程评论数量

  lessonMyLesson: "/trainingApi/v1/lesson/myLesson", // 我的课程
  lessonDelNote: "/trainingApi/v1/lesson/delNote", // 随堂笔记-删除笔记
  // 作业
  workBraillerDetail: "/trainingApi/v1/work/braillerDetail", // 作业-谭外拓展作业详情
  workTabs: "/trainingApi/v1/work/workTabs", // 作业-作业分类tab列表
  workJobList: "/trainingApi/v1/work/workJobList", // 作业-三类作业的内容列表
  workCommentList: "/trainingApi/v1/work/commentList", // 作业-课外拓展-发言评论列表
  workExperienceDetail: "/trainingApi/v1/work/experienceDetail", // 作业-心得体会作业详情
  workExperienceRecordDetail: "/trainingApi/v1/work/experienceRecordDetail", // 作业-必得体会提交记录详情
  workExperienceSubmitRecord: "/trainingApi/v1/work/experienceSubmitRecord", // 作业-心得体会提交记录
  workPracticeDetail: "/trainingApi/v1/work/practiceDetail", // 作业-主题实践详情
  workPracticeRecord: "/trainingApi/v1/work/practiceRecord", // 作业-主题实践-提交记录列表
  workSendComment: "/trainingApi/v1/work/sendComment", // 作业-课外拓展-发表评论 (json)
  workSendSns: "/trainingApi/v1/work/sendSns", // 作业-课外拓展-发表留言 (json)
  workSnsList: "/trainingApi/v1/work/snsList", // 作业-课外拓展发言列表
  workSnsZan: "/trainingApi/v1/work/snsZan", // 作业-课外拓展发言点赞
  workWriteExperience: "/trainingApi/v1/work/writeExperience", // 作业-写心得 (json)
  workWritePractice: "/trainingApi/v1/work/writePractice", // 作业-主题实践-提交记录
  // 考试
  examEndExamRecord: "/trainingApi/v1/exam/endExamRecord", // 模拟考试考试记录
  examInfo: "/trainingApi/v1/exam/examInfo", // 模拟\结业考试信息
  examLessonList: "/trainingApi/v1/exam/examLessonList", // 测验章节列表
  examRecordDetail: "/trainingApi/v1/exam/examRecordDetail", // 查看试卷答题
  examTab: "/trainingApi/v1/exam/examTab", // 考试tab
  exitExam: "/trainingApi/v1/exam/exitExam", // 退出考试
  examGetEndTime: "/trainingApi/v1/exam/getEndTime", // 获取考试结束倒计时
  examGetStartTime: "/trainingApi/v1/exam/getStartTime", // 获取考试开始倒计时
  leaveExam: "/trainingApi/v1/exam/leaveExam", // 考试切屏1次
  markQuestion: "/trainingApi/v1/exam/markQuestion", // 标记题目
  saveExamAnswer: "/trainingApi/v1/exam/saveExamAnswer", // 临时保存答题记录(json)
  startExam: "/trainingApi/v1/exam/startExam", // 开始考试（模拟和结业）
  startLessonExam: "/trainingApi/v1/exam/startLessonExam", // 开始考试（章节测验）
  submitExam: "/trainingApi/v1/exam/submitExam", // 提交考试(json)
  // 我的
  userEditUserInfo: "/trainingApi/v1/user/editUserInfo", // 修改用户基本信息-个人中心
  userSendMail: "/trainingApi/v1/user/sendMail", // 发送邮件验证码
  userPhaselist: "/trainingApi/v1/user/phaselist", // 入党阶段列表， 选项值请使用appId
  userTreeList: "/trainingApi/v1/user/treeList", // 组织机构树
  userIdentityList: "/trainingApi/v1/user/identityList", // 注册表单用户身份下拉选择列表
  userInfo: "/trainingApi/v1/user/userInfo", // 用户基本信息-个人中心
  userStageList: "/trainingApi/v1/user/stageList", // 分期列表-个人中心
  userGraduation: "/trainingApi/v1/user/graduation", // 结业证书-个人中心
  userRanking: "/trainingApi/v1/user/ranking", // 排行榜-个人中心
  userStageReport: "/trainingApi/v1/user/stageReport", // 成绩单-个人中心
  userStudyInfo: "/trainingApi/v1/user/studyInfo", // 学习情况-个人中心
  userStudyTime: "/trainingApi/v1/user/studyTime", // 学习时长统计-个人中心
  userWrongQuestions: "/trainingApi/v1/user/wrongQuestions", // 我的错題-个人中心
  userWrongQuestionsDist: "/trainingApi/v1/user/wrongQuestionsDist", // 我的错題分布-个人中心
  userUpdatePassword: "/trainingApi/v1/user/updatePassword", // 修改密码-个人中心 (json)

  // 党支部书记
  partySnsSubmit: "/trainingApi/v1/party/submitSns", // 党务研讨发言
  partySnsList: "/trainingApi/v1/party/snsList", // 党务研讨发言列表
  partyCommentList: "/trainingApi/v1/party/snsCommentList", // 党务研讨评论列表
  partyCommentSubmit: "/trainingApi/v1/party/submitComment", // 党务研讨发表评论
  partySnsVote: "/trainingApi/v1/party/snsZan", // 党务研讨发言点赞
  partyTalkList: "/trainingApi/v1/party/talkList", // 党务研讨话题列表

  // 个人空间
  centerEditUser: "/trainingApi/v1/center/editUser", // 编辑用户信息
  centerMyMessages: "/trainingApi/v1/center/myMessages", // 我的消息列表
  centerSetRead: "/trainingApi/v1/center/setRead", // 根据ID列表设置为已读（json）
  centerSetReadAll: "/trainingApi/v1/center/setReadAll", // 所有记录设置为已读
  centerSetReadSingle: "/trainingApi/v1/center/setReadSingle", // 单条记录设置为已读
  centerUserDetail: "/trainingApi/v1/center/userDetail", // 用户详情
  centerWorkbenches: "/trainingApi/v1/center/workbenches", // 我的工作台
  messageDetail: "/trainingApi/v1/center/messageDetail", // 消息详情
  partyCardDetail: "/trainingApi/v1/partyCard/cardRecordDetail", // 贺卡详情
  centerMyTaskNums: "/trainingApi/v1/center/myTaskNums", // 待办任务数量
  centerMyTaskList: "/trainingApi/v1/center/myTaskList", // 待办任务列表
  centerTaskDetail: "/trainingApi/v1/task/taskDetail", // 任务详情
  centerCheckUserTask: "/trainingApi/v1/task/checkUserTask", // 用户任务审核
  taskUploadTaskFile: "/trainingApi/v1/task/uploadTaskFile", // 上传文件
  taskUploadTaskData: "/trainingApi/v1/task/uploadTaskData", // 提交数据
  taskCheckDetail: "/trainingApi/v1/task/taskCheckDetail", // 我审核的、我抄送的 任务详情
  taskCheckUserTask: "/trainingApi/v1/task/checkUserTask", // 用户任务审核

  // 入党申请
  developAppList: "/trainingApi/v1/develop/appList", // 四大阶段列表
  developAppTaskList: "/trainingApi/v1/develop/appTaskList", // 阶段下任务列表
  developFillRequirement: "/trainingApi/v1/develop/fillRequirement", // 任务的填写要求
  developMySubmitList: "/trainingApi/v1/develop/mySubmitList", // 任务的提交记录
  developSubmit: "/trainingApi/v1/develop/submit", // 提交或存草稿
  developTaskDraft: "/trainingApi/v1/develop/taskDraft", // 获取草稿
  developDocDetail: "/trainingApi/v1/develop/docDetail", // 获取提交记录详情

  // 我的工作台-党组织活动
  orgActList: "/trainingApi/v1/orgAct/actList", // 我的活动列表
  orgActLeave: "/trainingApi/v1/orgAct/actLeave", // 请假
  orgActDetail: "/trainingApi/v1/orgAct/actDetail", // 活动会议详情
  orgActVoteItemList: "/trainingApi/v1/orgAct/voteItemList", // 民主评议投票项目列表
  orgActVoteList: "/trainingApi/v1/orgAct/voteList", // 民主评议投票列表
  orgActVoteResult: "/trainingApi/v1/orgAct/voteResult", // 提交投票(json)
  orgActGetVoteResult: "/trainingApi/v1/orgAct/getVoteResult", // 获取提交投票

  // 集中培训活动
  activityList: "/trainingApi/v1/activity/myActivity", // 活动列表
  activityDetail: "/trainingApi/v1/activity/activityDetail", // 活动列表
  activitybaoMing: "/trainingApi/v1/activity/baoMing", // 活动报名
  activityProjectList: "/trainingApi/v1/activity/projectList", // 活动项目列表
  dyActivityProjectList: "/trainingApi/v1/activity/dyProjectList", // 党员活动项目列表
  activityProjectLeave: "/trainingApi/v1/activity/projectLeave", // 活动请假
  activityProjectLeaveDetail: "/trainingApi/v1/activity/projectLeaveDetail", // 活动请假详情
  activityUserQrcodeScanLog: "/trainingApi/v1/activity/userQrcodeScanLog", // 活动签到

  // 干部
  leaderExamList: "/trainingApi/v1/exam/examList", // 考试测验列表
  leaderTopicList: "/trainingApi/v1/topic/newTopicList", // 专题列表
  leaderCenterGroupActivityDetail: "/trainingApi/v1/centerGroup/activityDetail", // 活动详情
  leaderCenterGroupActivityLeave: "/trainingApi/v1/centerGroup/activityLeave", // 活动请假
  leaderCenterGroupAddUserExperience:
    "/trainingApi/v1/centerGroup/addUserExperience", // 活动发言
  leaderCenterGroupGetUserExperience:
    "/trainingApi/v1/centerGroup/getUserExperience", // 查看活动发言
  leaderCenterGroupMyActivity: "/trainingApi/v1/centerGroup/myActivity", // 我的活动列表
  leaderCenterGroupUserScanLog: "/trainingApi/v1/centerGroup/userQrcodeScanLog", // 用户活动签到情况
  leaderLiveActList: "/trainingApi/v1/live/liveActList", // 线上直播培训列表
  leaderActivityGbActivity: "/trainingApi/v1/activity/gbActivity", // 干部线下活动列表
  leaderSelfStudyStudyInfo: "/trainingApi/v1/selfStudy/studyInfo", // 学习目标，在线自学页面上面的几个圈和右边的块
  leaderLessonList: "/trainingApi/v1/cadre/lessonList", // 在线课程自学页面 - 我的课程列表
  leaderDiscussCount: "/trainingApi/v1/cadre/discussCount", // 播放器页面 - 课程讨论 - 讨论数量
  leaderLessonReadList: "/trainingApi/v1/cadre/lessonReadList", // 专栏页面－推荐阅读（分页）
  leaderLessonVideoDetail: "/trainingApi/v1/cadre/lessonVideoResourceDetail", // 播放器页面 －视频详情
  leaderLessonVideoList: "/trainingApi/v1/cadre/lessonVideoResourceList", // 播放器页面 － 视频播放列表
  leaderSetResourceTime: "/trainingApi/v1/cadre/setResourceTime", // 播放器页面 － 保存视频播放时间点，10秒一次；只有未完成的视频才提交保存请求
  leaderSpecialDetail: "/trainingApi/v1/cadre/specialDetail", // 专栏首页 - 专栏详情
  leaderSpecialDetailLesson: "/trainingApi/v1/cadre/stageVideos", // 专栏首页 - 专栏详情课程列表
  leaderSpecialList: "/trainingApi/v1/cadre/specialList", // 在线课程自学页面 - 专栏列表
  leaderLessonTagList: "/trainingApi/v1/cadreIndex/lessonTagList", // 干部首页课程分类
  leaderUserInfo: "/trainingApi/v1/cadreIndex/userInfo", // 干部首页个人信息
  lastYear: "/trainingApi/v1/topic/topicLastYear",

  // 党员
  partyIndexBaseActList: "/trainingApi/v1/partyIndex/baseActList", // 首页党员基本培训
  partyIndexPartyActList: "/trainingApi/v1/partyIndex/partyActList", // 党员基本培训-活动列表
  partyIndexUserInfo: "/trainingApi/v1/partyIndex/userInfo", // 党员培训个人信息
  partyIndexPartyActDetail: "/trainingApi/v1/partyIndex/partyActDetail", // 党员基本培训-活动详情
  userActivityMendDetail: "/trainingApi/v1/partyIndex/userActivityMendDetail", // 党员基本培训-用户补课详情
};

export default API;
